export type TPageType =
	| 'Global'
	| 'Product Page'
	| 'Product Page Shop'
	| 'Study Fulltime Page'
	| 'Study Allongside Page'
	| 'Study Distance Page'
	| 'Degree Type Page'
	| 'Location Overview'
	| 'Location Page'
	| 'Study Topics'
	| 'Home'
	| 'Application Page'
	| 'Blog Overview'
	| 'Blog Detail Page'
	| 'Event Overview Page'
	| 'Event registration Form'
	| 'Info Material Page'
	| 'Information Overview Page'
	| 'Landing Page'
	| 'Thank You Page';

// see https://docs.google.com/spreadsheets/d/1-d0xXuxv1k8NPYnVuSLYizUKgnQlJOGTlgFK-gMzhGc/edit#gid=800050140
const pageTypes: { value: TPageType; selector?: string; paths?: string[] }[] = [
	{
		value: 'Product Page',
		selector: 'body.single-studium',
	},
	{
		value: 'Product Page Shop',
		selector: 'body.single-product',
	},
	{
		value: 'Study Fulltime Page',
		selector: 'body.single-page.vollzeitstudium,body.page.vollzeitstudium',
	},
	{
		value: 'Study Allongside Page',
		selector: 'body.single-page.berufsbegleitend',
		paths: [ '/bachelor/berufsbegleitend/' ],
	},
	{
		value: 'Study Distance Page',
		selector: 'body.single-page.fernstudium',
		paths: [ '/fernstudium/bachelor/' ],
	},
	{
		value: 'Degree Type Page',
		selector:
			'body.single-page.bachelor,body.single-page.master,body.page.bachelor,body.page.master',
	},
	{
		value: 'Location Overview',
		selector: 'body.single-page.standorte',
	},
	{
		value: 'Location Page',
		selector: 'body.single-standort',
	},
	{
		value: 'Study Topics',
		selector: 'body.single-themenwelt',
	},
	{
		value: 'Home',
		selector: 'body.front-page-data',
	},
	{
		value: 'Application Page',
		selector: 'body.single-page.bewerbung,body.page.bewerbung',
	},
	{
		value: 'Blog Overview',
		selector: 'body.single-page.blog',
	},
	{
		value: 'Blog Detail Page',
		selector: 'body.single-blog',
	},
	{
		value: 'Event Overview Page',
		selector: 'body.single-page.termine,body.single-events_import',
	},
	{
		value: 'Event registration Form',
		selector:
			'body.parent-pageid-140464.page-child.anmeldung,body.termin-anmeldung',
	},
	{
		value: 'Info Material Page',
		selector: 'body.single-page.infomaterial,body.page.infomaterial',
	},
	{
		value: 'Information Overview Page',
		selector: 'body.single-page.studienberatung',
	},
	{
		value: 'Landing Page',
		selector: 'body.single-paid-landingpage',
		paths: [ '/lp/' ],
	},
	{

		value: 'Thank You Page',
		paths: [ '/gtp/', '/gtp/crm/', '/tp/', '/tp/crm/' ],
	},
];

const getPageType = (
	validTypes = pageTypes.map( ( t ) => t.value )
): TPageType => {
	for ( const type of pageTypes.filter( ( t ) =>
		validTypes.includes( t.value )
	) ) {
		if ( document.querySelector( type.selector ) ) {
			return type.value;
		}
		if ( type.paths && type.paths.includes( window.location.pathname ) ) {
			return type.value;
		}
	}
	return 'Global';
};

export default getPageType;
